<template>
  <div id="vmodal" class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header bg-blue p-2">
          <h4 class="modal-title color-white">{{ modalTitle }}</h4>
          <button type="button" class="close color-white" style="opacity: 1;" data-dismiss="modal">&times;</button>
        </div>

        <div class="modal-body">
          <div v-html="modalMessage" class="text-center"></div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">Đóng</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Modal",
    props: {
      modalTitle: String,
      modalMessage: String
    }
  }
</script>

<style scoped>
  .modal-header{
    padding: 0.5rem 1rem;
  }
  .modal-title{
    font-size: 18px;
    font-weight: bold;
  }
  .modal-body{
    padding: 0.5rem 1rem;
  }
  .modal-footer{
    padding: 0.3rem 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue